import { useEffect } from "react";
import { applySeo, jsonLd, type SeoPage } from "@/lib/seo";

export function SeoPage({ page, schema }: { page: SeoPage; schema?: object }) {
  useEffect(() => { applySeo(page); }, [page.title, page.description, page.path, page.noindex, page.type]);
  return schema ? <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLd(schema) }} /> : null;
}